import { motion } from "framer-motion";
import { INSTAGRAM } from "@/constants/testIds";

const feed = [
  "https://images.unsplash.com/photo-1655255114527-d0a834d9a774?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1589713680561-1d0b6945a582?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1621341103818-01dada8c6ef8?auto=format&fit=crop&w=800&q=80",
  "https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1588444650733-d0767b753fc8?auto=format&fit=crop&w=800&q=80",
];

export default function Instagram() {
  return (
    <section
      id="journal"
      data-testid={INSTAGRAM.section}
      className="relative bg-[#F7F5F2] px-6 md:px-10 py-28"
    >
      <div className="flex items-end justify-between border-b border-[#1C1C1A]/10 pb-8 mb-10">
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#1C1C1A]/70 mb-3">
            Ch. 07 — Journal
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1] tracking-[-0.02em]">
            <a
              href="https://www.instagram.com/diamant_jewellers?igsh=MWMwdDI4YTVubWQ0bQ=="
              target="_blank"
              rel="noreferrer noopener"
              className="link-underline"
            >
              <span className="italic text-[#9A8B73]">@diamant</span>jewellers
            </a>
          </h2>
        </div>
        <a
          href="https://www.instagram.com/diamant_jewellers?igsh=MWMwdDI4YTVubWQ0bQ=="
          target="_blank"
          rel="noreferrer noopener"
          className="link-underline text-xs uppercase tracking-[0.24em] font-sans hidden md:inline-block"
        >
          Follow on Instagram →
        </a>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
        {feed.map((src, i) => (
          <motion.a
            key={i}
            href="https://www.instagram.com/diamant_jewellers?igsh=MWMwdDI4YTVubWQ0bQ=="
            target="_blank"
            rel="noreferrer noopener"
            data-testid={INSTAGRAM.item(i)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{
              duration: 0.7,
              delay: i * 0.05,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="group relative overflow-hidden aspect-square block"
          >
            <img
              src={src}
              alt={`Instagram tile ${i + 1}`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
            />
            <div className="absolute inset-0 border border-[#F7F5F2] scale-95 opacity-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500" />
          </motion.a>
        ))}
      </div>
    </section>
  );
}
